<template>
  <div class="table-responsive mt-3 mc-table__cut-off-automation">
    <McGrapqlTable
      ref="table-ref"
      :apiClient="query"
      :fields="fields"
      :searchable="true"
      :hasFilter="true"
      :withCard="true"
      :hasDelete="false"
      :hasMassSelect="true"
      :hasDisabled="true"
      :customHandlers="customHandlers"
      :activeFilters="activeFilters"
      trackBy="vehicleId"
      transformDataKey="vehicle"
      transformDataID="id"
    >
      <template #button-filter="{ isSelected }">
        <div class="d-flex justify-content-between">
          <McInlineFilter
            :filterItems="filteredItems"
            :activeKeys="activeFilters['scheduleType']"
            @update:activeKeys="
              handleChangeActiveFilters([{ key: 'scheduleType', values: $event }])
            "
          />

          <ModalFilter
            :activeFilters="activeFilters"
            :isSelected="isSelected"
            :selectedItems="$refs['table-ref']?.items"
            :selectedIds="$refs['table-ref']?.selectedIds"
            @handleChangeActiveFilters="handleChangeActiveFilters"
            @handleClearSchedule="handleClearSchedule"
            @handleUpdateStatus="handleUpdateStatus"
          />
        </div>
      </template>
      <template #cell(licensePlate)="{ item }">
        <a
          @click="
            $router.push({
              name: 'Detail Setting Engine Off Automation',
              params: { id: item.vehicle.id },
            })
          "
        >
          <strong class="text-primary">
            {{ item.vehicle.licensePlate }}
          </strong>
        </a>
      </template>
      <template #cell(vehicle2Vgroup)="{ item }">
        <div v-if="item?.vehicle.vehicle2Vgroup.length">
          <b-tooltip
            v-if="item.vehicle.vehicle2Vgroup.length > 3"
            :target="`vgroup-${item?.vehicle.id}`"
            placement="bottom"
          >
            {{ item.vehicle.vehicle2Vgroup.map((vgroup) => vgroup.vgroup.name).join(', ') }}
          </b-tooltip>
          <span :id="`vgroup-${item?.vehicle.id}`" class="mc-ellipsis">
            {{
              item.vehicle.vehicle2Vgroup
                .slice(0, 2)
                .map((vgroup) => vgroup.vgroup.name)
                .join(', ')
            }}
            {{ item.vehicle.vehicle2Vgroup.length > 3 ? '...' : '' }}
          </span>
        </div>
        <span v-else>-</span>
      </template>
      <template #cell(operationTimeMonday)="{ item }">
        <template v-if="item.operationTime.mon && item.operationTime.mon.length">
          <div v-for="(time, index) in item.operationTime.mon" :key="index">
            {{ time.startTime.substring(0, 5) }} - {{ time.endTime.substring(0, 5) }}
          </div>
        </template>
        <span v-else>-</span>
      </template>
      <template #cell(operationTimeTuesday)="{ item }">
        <template v-if="item.operationTime.tue && item.operationTime.tue.length">
          <div v-for="(time, index) in item.operationTime.tue" :key="index">
            {{ time.startTime.substring(0, 5) }} - {{ time.endTime.substring(0, 5) }}
          </div>
        </template>
        <span v-else>-</span>
      </template>
      <template #cell(operationTimeWednesday)="{ item }">
        <template v-if="item.operationTime.wed && item.operationTime.wed.length">
          <div v-for="(time, index) in item.operationTime.wed" :key="index">
            {{ time.startTime.substring(0, 5) }} - {{ time.endTime.substring(0, 5) }}
          </div>
        </template>
        <span v-else>-</span>
      </template>
      <template #cell(operationTimeThursday)="{ item }">
        <template v-if="item.operationTime.thu && item.operationTime.thu.length">
          <div v-for="(time, index) in item.operationTime.thu" :key="index">
            {{ time.startTime.substring(0, 5) }} - {{ time.endTime.substring(0, 5) }}
          </div>
        </template>
        <span v-else>-</span>
      </template>
      <template #cell(operationTimeFriday)="{ item }">
        <template v-if="item.operationTime.fri && item.operationTime.fri.length">
          <div v-for="(time, index) in item.operationTime.fri" :key="index">
            {{ time.startTime.substring(0, 5) }} - {{ time.endTime.substring(0, 5) }}
          </div>
        </template>
        <span v-else>-</span>
      </template>
      <template #cell(operationTimeSaturday)="{ item }">
        <template v-if="item.operationTime.sat && item.operationTime.sat.length">
          <div v-for="(time, index) in item.operationTime.sat" :key="index">
            {{ time.startTime.substring(0, 5) }} - {{ time.endTime.substring(0, 5) }}
          </div>
        </template>
        <span v-else>-</span>
      </template>
      <template #cell(operationTimeSunday)="{ item }">
        <template v-if="item.operationTime.sun && item.operationTime.sun.length">
          <div v-for="(time, index) in item.operationTime.sun" :key="index">
            {{ time.startTime.substring(0, 5) }} - {{ time.endTime.substring(0, 5) }}
          </div>
        </template>
        <span v-else>-</span>
      </template>
      <template #cell(cutOffStatus)="{ item }">
        <McToggle
          placement="left"
          :value="item.isActive"
          :displayTooltip="true"
          :tooltipText="getTooltipText(item)"
          :disabled="
            ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].every(
              (day) => item.operationTime[day].length === 0
            )
          "
          tooltipPosition="left"
          @change="singleUpdateStatus(item)"
        />
      </template>
    </McGrapqlTable>
  </div>
</template>

<script>
import McGrapqlTable from '@/components/McGrapqlTable'
import McInlineFilter from '@/components/McInlineFilter'
import McToggle from '@/components/McToggle'
import ModalFilter from '../components/scheduled/ModalFilter.vue'
import getFields from '../lib/fields/scheduled'
import filteredItems from '../lib/filter/scheduled'
import {
  GET_CUT_OFF_ENGINES,
  BULK_UPDATE_CUT_OFF_ENGINES,
} from '@/services/api/setting/engineOff/engineOff'

export default {
  components: {
    McGrapqlTable,
    McInlineFilter,
    ModalFilter,
    McToggle,
  },
  data() {
    return {
      customHandlers: {
        handleDisabledRow: (data) => {
          const isAllOperationTimeEmpty = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].every(
            (day) => data.operationTime[day].length === 0
          )

          if (isAllOperationTimeEmpty) {
            return true
          }
        },
      },
      scheduledField: getFields(this),
      filteredItems,
      activeFilters: {
        status: 'all',
      },
      filter: [],
      selectedIds: [],
    }
  },
  computed: {
    fields() {
      return this.scheduledField
    },
    query() {
      return {
        get: async (filter) => {
          const activeFilters = { ...this.activeFilters }

          if (activeFilters.status === 'all') {
            delete activeFilters.status
          }

          if (activeFilters.scheduleType && Array.isArray(activeFilters.scheduleType)) {
            activeFilters.scheduleType = activeFilters.scheduleType[0]
            if (activeFilters.scheduleType === 'NotScheduled') {
              delete activeFilters.status
              delete activeFilters.days
              delete activeFilters.startTime
              delete activeFilters.endTime
            }
          }
          const res = await this.$apollo.query({
            query: GET_CUT_OFF_ENGINES,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
                ...activeFilters,
              },
            },
          })

          return res.data.cutoffEngines.cutOffEngines
        },
      }
    },
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.scheduledField = getFields(this)
      },
      immediate: true,
    },
  },
  methods: {
    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        this.$delete(this.activeFilters, filter.key)

        if (
          filter.values === null ||
          filter.values === undefined ||
          filter.values === '' ||
          filter.values === false
        )
          return
        if (Array.isArray(filter.values) && filter.values.length === 0) return

        this.$set(this.activeFilters, filter.key, filter.values)
      })

      this.filter = filters
    },
    getTooltipText(data) {
      const isAllOperationTimeEmpty = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].every(
        (day) => data.operationTime[day].length === 0
      )

      if (isAllOperationTimeEmpty) {
        return this.$t('setting.cutOffAutomation.message.vehicleNotSchedule')
      }

      return data.isActive
        ? `${this.$t('global.currentStatus')}<strong> ${this.$t('global.active')}</strong>`
        : `${this.$t('global.currentStatus')}<strong> ${this.$t('global.nonActive3')}</strong>`
    },
    async handleClearSchedule() {
      const selectedIds = Object.keys(this.$refs['table-ref'].selectedIds)
        .filter((key) => this.$refs['table-ref'].selectedIds[key])
        .map(Number)

      const payload = {
        vehicleIds: selectedIds,
        isResetSchedule: true,
      }

      const response = await this.updateCutOffEngines(payload)

      if (!response.data.updateCutOffEngines.isSuccessful) {
        this.$mcToast.error({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                tag: 'span',
                html: this.$t('setting.cutOffAutomation.message.clearScheduleFailed', {
                  selected: `<strong>${selectedIds.length}</strong>`,
                }),
              },
            ],
          },
        })
      }
      
      this.$mcToast.success({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'span',
              html: this.$t('setting.cutOffAutomation.message.clearScheduleSuccess', {
                selected: `<strong>${selectedIds.length}</strong>`,
              }),
            },
          ],
        },
      })

      this.$refs['table-ref'].handleUnselectAll()
      this.$refs['table-ref'].getData({
        limit: this.$refs['table-ref'].limit,
        page: 1,
        sorts: this.$refs['table-ref'].stringSorts(),
      })
    },
    async handleUpdateStatus(data) {
      const selectedIds = Object.keys(this.$refs['table-ref'].selectedIds)
        .filter((key) => this.$refs['table-ref'].selectedIds[key])
        .map(Number)

      const status = data === 'Active' ? true : false
      const statusText = status ? this.$t('global.active') : this.$t('global.nonActive3')

      const payload = {
        vehicleIds: selectedIds,
        isActive: status,
      }

      const response = await this.updateCutOffEngines(payload)

      if (!response.data.updateCutOffEngines.isSuccessful) {
        this.$mcToast.error({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                tag: 'span',
                html: this.$t('setting.cutOffAutomation.message.updateScheduleFailed', {
                  selected: `<strong>${selectedIds.length}</strong>`,
                }),
              },
              { tag: 'strong', text: statusText, class: '__status' },
            ],
          },
        })
      }

      this.$mcToast.success({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'span',
              html: this.$t('setting.cutOffAutomation.message.updateScheduleSuccess', {
                selected: `<strong>${selectedIds.length}</strong>`,
              }),
            },
            { tag: 'strong', text: statusText, class: '__status' },
          ],
        },
      })

      this.$refs['table-ref'].handleUnselectAll()
      this.$refs['table-ref'].getData({
        limit: this.$refs['table-ref'].limit,
        page: 1,
        sorts: this.$refs['table-ref'].stringSorts(),
      })
    },
    async singleUpdateStatus(data) {
      const selectedIds = [parseInt(data.vehicle.id)]

      const status = data.isActive ? false : true
      const statusText = status ? this.$t('global.active') : this.$t('global.nonActive3')

      const payload = {
        vehicleIds: selectedIds,
        isActive: status,
      }

      const response = await this.updateCutOffEngines(payload)

      if (!response.data.updateCutOffEngines.isSuccessful) {
        this.$mcToast.error({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              { tag: 'span', text: this.$t('setting.cutOffAutomation.message.statusFailed') },
              { tag: 'strong', text: statusText, class: '__status' },
            ],
          },
        })
      }
      this.$mcToast.success({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            { tag: 'span', text: this.$t('setting.cutOffAutomation.message.statusSuccess') },
            { tag: 'strong', text: statusText, class: '__status' },
          ],
        },
      })

      this.$refs['table-ref'].handleUnselectAll()
      this.$refs['table-ref'].getData({
        limit: this.$refs['table-ref'].limit,
        page: 1,
        sorts: this.$refs['table-ref'].stringSorts(),
      })
    },
    async updateCutOffEngines(payload) {
      const response = await this.$apollo.mutate({
        mutation: BULK_UPDATE_CUT_OFF_ENGINES,
        variables: {
          input: payload,
        },
      })
      return response
    },
  },
}
</script>
